/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import OrdersOrderOrderLineItems from './OrdersOrderOrderLineItems';
import OrdersOrderShippingAddress from './OrdersOrderShippingAddress';

/**
 * The OrdersOrder model module.
 * @module model/OrdersOrder
 * @version v0.3
 */
export default class OrdersOrder {
  /**
   * Constructs a new <code>OrdersOrder</code>.
   * @alias module:model/OrdersOrder
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>OrdersOrder</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/OrdersOrder} obj Optional instance to populate.
   * @return {module:model/OrdersOrder} The populated <code>OrdersOrder</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new OrdersOrder();
      if (data.hasOwnProperty('carrier'))
        obj.carrier = ApiClient.convertToType(data['carrier'], 'String');
      if (data.hasOwnProperty('order_type'))
        obj.orderType = ApiClient.convertToType(data['order_type'], 'String');
      if (data.hasOwnProperty('patient_id'))
        obj.patientId = ApiClient.convertToType(data['patient_id'], 'String');
      if (data.hasOwnProperty('requires_approval'))
        obj.requiresApproval = ApiClient.convertToType(data['requires_approval'], 'Boolean');
      if (data.hasOwnProperty('order_line_items'))
        obj.orderLineItems = ApiClient.convertToType(data['order_line_items'], [OrdersOrderOrderLineItems]);
      if (data.hasOwnProperty('submission_id'))
        obj.submissionId = ApiClient.convertToType(data['submission_id'], 'String');
      if (data.hasOwnProperty('promotion_code'))
        obj.promotionCode = ApiClient.convertToType(data['promotion_code'], 'String');
      if (data.hasOwnProperty('shipping_address'))
        obj.shippingAddress = OrdersOrderShippingAddress.constructFromObject(data['shipping_address']);
      if (data.hasOwnProperty('billing_address'))
        obj.billingAddress = OrdersOrderShippingAddress.constructFromObject(data['billing_address']);
      if (data.hasOwnProperty('metadata'))
        obj.metadata = ApiClient.convertToType(data['metadata'], {'String': Object});
    }
    return obj;
  }
}

/**
 * @member {String} carrier
 */
OrdersOrder.prototype.carrier = undefined;

/**
 * @member {String} orderType
 */
OrdersOrder.prototype.orderType = undefined;

/**
 * @member {String} patientId
 */
OrdersOrder.prototype.patientId = undefined;

/**
 * @member {Boolean} requiresApproval
 */
OrdersOrder.prototype.requiresApproval = undefined;

/**
 * @member {Array.<module:model/OrdersOrderOrderLineItems>} orderLineItems
 */
OrdersOrder.prototype.orderLineItems = undefined;

/**
 * @member {String} submissionId
 */
OrdersOrder.prototype.submissionId = undefined;

/**
 * @member {String} promotionCode
 */
OrdersOrder.prototype.promotionCode = undefined;

/**
 * @member {module:model/OrdersOrderShippingAddress} shippingAddress
 */
OrdersOrder.prototype.shippingAddress = undefined;

/**
 * @member {module:model/OrdersOrderShippingAddress} billingAddress
 */
OrdersOrder.prototype.billingAddress = undefined;

/**
 * Any JSON-formatted data you want to associate with this object
 * @member {Object.<String, Object>} metadata
 */
OrdersOrder.prototype.metadata = undefined;

